// import React, { ReactNode } from 'react';
// import styles from './styles.module.css';
// import ToolbarIcons from '@/icons/toolbar';
// import SelectItems from '../SelectItems';

// interface MoreBoxType {
//   children?: ReactNode;
//   id?: string;
//   list?: any;
//   boxClassName?: string;
//   selected?: number | string;
//   icon?: ReactNode;
//   iconStyle?: string;
//   className?: string;
// }

// export default function MoreBox({
//   list = [],
//   id: propId, // ← rename to avoid conflict
//   boxClassName = '',
//   selected = '',
//   icon = null,
//   iconStyle = '',
//   className = '',
//   children = null,
// }: MoreBoxType) {
//   // Each MoreBox has its OWN open state
//   const [isOpen, setIsOpen] = React.useState(false);

//   // Generate unique ID if not provided
//   const dropdownId = propId || `morebox-${React.useId()}`;

//   return (
//     <div className={`${styles.container} ${className}`}>
//       <div
//         onClick={(e) => {
//           e.stopPropagation();
//           setIsOpen((prev) => !prev); // Simple toggle — no shared state!
//         }}
//         className={`${styles.icon} ${iconStyle}`}
//       >
//         {icon ? icon : <ToolbarIcons.MoreIcon className={`${styles.moreIcon}`} />}
//       </div>

//       {isOpen && (
//         <SelectItems
//           list={list}
//           setShowItems={() => setIsOpen(false)} // Only closes this one
//           id={dropdownId}
//           className={boxClassName}
//           selected={selected}
//           onItemClick={() => setIsOpen(false)} // Optional: close on select
//           isOpen={isOpen}
//         >
//           {children}
//         </SelectItems>
//       )}
//     </div>
//   );
// }
// ================
import React, { ReactNode, useEffect, useState } from 'react';
import styles from './styles.module.css';
import ToolbarIcons from '@/icons/toolbar';
import SelectItems from '../SelectItems';

interface MoreBoxType {
  children?: ReactNode;
  id?: string;
  list?: any;
  boxClassName?: string;
  selected?: number | string;
  icon?: ReactNode;
  iconStyle?: string;
  className?: string;
  activeStyle?: string;
}
export default function MoreBox({
  list = [],
  id = 'moreBox',
  boxClassName = '',
  selected = '',
  icon = null,
  iconStyle = '',
  className = '',
  children = null,
  activeStyle = '',
}: MoreBoxType) {
  const [showItems, setShowItems] = useState<string | number | null>(null);
  console.log('showItems==', showItems);
  const [mounted, setMounted] = React.useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  if (!mounted) return null;
  return (
    <div
      className={`${styles.container} ${showItems && `${styles.activeIcon} ${activeStyle}`} ${className}`}
      id={id}
    >
      <div
        // onClick={(e) => {
        //   // e.preventDefault();
        //   // e.stopPropagation();
        //   // if (showItems == id) {
        //   //   setShowItems('');
        //   // } else {
        //   //   setShowItems(id);
        //   // }
        // }}
        onClick={(e) => {
          e.stopPropagation(); // Critical
          setShowItems((prev) => (prev === id ? null : id));
        }}
        className={`${styles.icon} ${iconStyle} `}
      >
        {icon ? icon : <ToolbarIcons.MoreIcon className={`${styles.moreIcon}`} />}
      </div>
      {showItems == id && (
        <SelectItems
          list={list}
          // onClick={(x) => item?.onClick(x)}
          showItems={showItems}
          setShowItems={setShowItems}
          id={id}
          className={boxClassName}
          selected={selected}
        >
          {children}
        </SelectItems>
      )}
    </div>
  );
}
